import { useNavigate } from 'react-router-dom';
import { ServiceRequestsIcon } from '../../../../../assets/icons';
import Button from '../../../../../common/components/xepp/button/Button';
import styles from './NewServiceTypePage.module.scss'
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { setFormDescription, setFormName, setIsExternal } from '../../../../../stores/slices/service-type-slice';
import { RootState } from '../../../../../stores/store'
import { toast } from 'react-toastify';
import ToggleSlider from '../../../../../common/components/xepp/toggle-slider/ToggleSlider';

const NewServiceTypePage = () => {
    const currentState = useSelector((state: RootState) => state.serviceType);
    const dispatch = useDispatch();
    const navigator = useNavigate();

    const [serviceTypeForm, setForm] = useState({
        formName: currentState.name,
        formDescription: currentState.description
    });

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    }

    const onContinueClick = () => {
        const { formName, formDescription } = serviceTypeForm;
        if (formName === '' || formName === undefined || formDescription === '' || formDescription === undefined){
            toast.warning("Name and Description are required")
            return;
        }

        dispatch(setFormName(formName))
        dispatch(setFormDescription(formDescription))
        navigator('custom-form');
    }

    const onCancelClick = () => {
        dispatch(setFormName(''))
        dispatch(setFormDescription(''))
        navigator(-1);
    }

    return (
        <>
            <div className={styles.headerWrapper}>
                <div className={styles.iconContainer}>{<ServiceRequestsIcon />}</div>
                <h3>Add New Service Type</h3>
            </div>
            <div className={styles.bodyWrapper}>
                <div className={styles.bodyContainer}>
                    <div className={styles.content}>
                        <div className={styles.formNameRow}>
                            <div className={styles.formNameContainer}>
                                <span>Form Name</span>
                            </div>
                            <div className={styles.formNameValueContainer}>
                                <div className={styles.formNameInputContainer}>
                                    <input type='text' name='formName' value={serviceTypeForm.formName} onChange={handleChange} placeholder='Enter Form Name' />
                                </div>
                            </div>
                        </div>
                        <div className={styles.descriptionRow}>
                            <div className={styles.descriptionContainer}>
                                <span>Description</span>
                            </div>
                            <div className={styles.descriptionValueContainer}>
                                <div className={styles.descriptionInputContainer}>
                                    <textarea name='formDescription' value={serviceTypeForm.formDescription} onChange={handleChange} placeholder="Please provide a short description of the service you're requesting, including relevant details (e.g., timeline, or special requirements)" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.externalRow}>
                        <span>External Service Request</span>
                        <ToggleSlider
                            isActive={currentState.isExternal ?? false}
                            onChange={(value) => dispatch(setIsExternal(value))}
                        />
                    </div>
                    <div className={styles.footer}>
                        <Button
                            text={'Cancel Setup'}
                            onClick={ onCancelClick }
                            variant={'outline'}
                        />
                        <Button
                            text={'Continue Setup'}
                            onClick={ onContinueClick }
                            variant={'secondary'}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default NewServiceTypePage;